/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/PyramidTemplate/PyramidWindowsTemplate',[
        'lodash',
        'pixi',
        'util/eventhandler',
        'Arkadium/GameEngine/Core/EngineManagers',
        'CardUI/SupplyView',
        'CardUI/PileView',
        'CardUI/KeyboardNavigator',
        'SolitaireShared/CardLogic/Supply',
        'SolitaireShared/PyramidLogic/PyramidAuthority',
        'SolitaireShared/PyramidTemplate/PyramidInputInterpreter',
        'SolitaireShared/PyramidTemplate/PyramidCardAnimator',
        'Arkadium/GameEngine/Maths/Vector2',
        'util/SettingsManager', 'absolute'],
    function (_, PIXI, EventHandler, EngineManagers, SupplyView, PileView,
              KeyboardNavigator, Supply, PyramidAuthority, PyramidInputInterpreter, PyramidCardAnimator,
              Vector2, SettingsManager, Absolute) {
        "use strict";

        var PyramidWindowsTemplate = function () {
            this.initPyramidWindowsTemplate();
        };

        PyramidWindowsTemplate.prototype.initPyramidWindowsTemplate = function () {
            this._authorityReference = null;
            this._supplyViewReference = null;
            this._curAutoSolveView = null;
            this._curAutoSolveViewOnUpdated = new EventHandler();
            this.settingsManager = SettingsManager;
        };

        PyramidWindowsTemplate.prototype.CreateAuthority = function (challenge) {
            var authority = challenge != null
                ? challenge.ConstructAuthority()
                : new PyramidAuthority();

            authority.Setup();
            authority.CardSupply.DeckSeed = null;

            this._authorityReference = authority;
            return authority;
        };


        PyramidWindowsTemplate.prototype.Cleanup = function () {
            this.supplyView.OnMoveCardsEvent.remove(this.OnMoveCardsHandler);
            this.supplyView.CardSupply.OnDealEvent.remove(this.OnDealHandlerRef);
        };

        PyramidWindowsTemplate.prototype.CreateInputInterpreter = function (authority) {
            return new PyramidInputInterpreter(authority);
        };

        PyramidWindowsTemplate.prototype.CreateCardAnimator = function (supplyView) {
            return new PyramidCardAnimator(supplyView);
        };

        PyramidWindowsTemplate.prototype.TryAutoSolve = function (supplyView) {
        };

        PyramidWindowsTemplate.prototype.StopAutoSolving = function () {
        };


        PyramidWindowsTemplate.prototype.DoLayoutPiles = function (renderManager, supplyView) {
            var isLeft = SettingsManager.getSetting('pyramid', 'layoutDirection') === '1';
            var width = EngineManagers.Display.Width;
            var height = EngineManagers.Display.Height;
            var minWidth = 320;

            // reset all keyboard handlers
            _.forEach(supplyView.CardSupply.GetPileList(), function (p) {

                if (p != null) {
                    var pileView = supplyView.GetPileView(p);
                    if (pileView != null)
                        pileView.Keyboard.ResetKeypressHandlers();
                }
            });

            var pile;
            var cardScale = 0.915;
            var pileScale = 1.0;
            var rowScale = 0.75;

            if (width / (height) < 1.5) {
                cardScale *= 0.85;
                rowScale *= 0.85;
            }
            
            var botRow = 0.85 - 0.5;
            var row = [0.20 - 0.5, 0.27 - 0.5, 0.34 - 0.5, 0.41 - 0.5, 0.48 - 0.5, 0.54 - 0.5, 0.61 - 0.5];

            if (this._authorityReference.IsChallenge) {
                botRow = 0.805 - 0.5;
                row = [0.16 - 0.5, 0.23 - 0.5, 0.30 - 0.5, 0.37 - 0.5, 0.44 - 0.5, 0.50 - 0.5, 0.57 - 0.5];
            }

            var col =
                [
                    (0.0 / 14.0 - 0.5) * rowScale,
                    (1.0 / 14.0 - 0.5) * rowScale,
                    (2.0 / 14.0 - 0.5) * rowScale,
                    (3.0 / 14.0 - 0.5) * rowScale,
                    (4.0 / 14.0 - 0.5) * rowScale,
                    (5.0 / 14.0 - 0.5) * rowScale,
                    (6.0 / 14.0 - 0.5) * rowScale,
                    (7.0 / 14.0 - 0.5) * rowScale,
                    (8.0 / 14.0 - 0.5) * rowScale,
                    (9.0 / 14.0 - 0.5) * rowScale,
                    (10.0 / 14.0 - 0.5) * rowScale,
                    (11.0 / 14.0 - 0.5) * rowScale,
                    (12.0 / 14.0 - 0.5) * rowScale,
                    (13.0 / 14.0 - 0.5) * rowScale,
                    (14.0 / 14.0 - 0.5) * rowScale
                ];

            var colIndices = [7, 6, 8, 5, 7, 9, 4, 6, 8, 10, 3, 5, 7, 9, 11, 2, 4, 6, 8, 10, 12, 1, 3, 5, 7, 9, 11, 13];
            var rowIndices = [0, 1, 1, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6];

            var rightFocus = [21, 22, 15, 23, 16, 10, 24, 17, 11, 6, 25, 18, 12, 7, 3, 26, 19, 13, 8, 4, 1, 27, 20, 14, 9, 5, 2, 0];
            var leftFocus = [27, 26, 20, 25, 19, 14, 24, 18, 13, 9, 23, 17, 12, 8, 5, 22, 16, 11, 7, 4, 2, 21, 15, 10, 6, 3, 1, 0];

            //int[] midFocus = { 24, 23, 25, 22, 26, 21, 27, 17, 18, 16, 19, 15, 20, 12, 11, 13, 10, 14, 7, 8, 6, 9, 4, 3, 5, 1, 2, 0 };

            for (var i = 0; i < 28; i++) {
                pile = supplyView.GetPileView("Tableau" + i);

                pile.CardFacing = PileView.Facing.FaceUp;
                pile.PileMode = PileView.Layout.Pile;
                pile.DisplayType = PileView.Display.Blank; // No shadows without this line (probably engine bug with texture alpha and/or the depth buffer).
                pile.ScaleX = pileScale;
                pile.ScaleY = pileScale;
                pile.LogicalScreenPos = new Vector2(col[colIndices[i]], row[rowIndices[i]]);
                pile.InteractionMode = PileView.Interaction.Click;
                pile.AllowClickWhenEmpty = false;

                pile.KeyboardMode = PileView.KeyboardModes.TopCardIfAllowed;

                for (var k = 0; k < rightFocus.length; k++) {
                    if (rightFocus[k] == i) {
                        for (var j = k + 1; j < rightFocus.length; j++) {
                            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Tableau" + rightFocus[j]));
                        }
                        for (var j = 0; j < k; j++) {
                            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Tableau" + rightFocus[j]));
                        }
                        break;
                    }
                }
                for (var k = 0; k < leftFocus.length; k++) {
                    if (leftFocus[k] == i) {
                        for (var j = k + 1; j < leftFocus.length; j++) {
                            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Tableau" + leftFocus[j]));
                        }
                        for (var j = 0; j < k; j++) {
                            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Tableau" + leftFocus[j]));
                        }
                        break;
                    }
                }
                if (colIndices[i] < 6)
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Stock"));
                else if (colIndices[i] > 8)
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Waste"));
                else
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Stock"));

                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Tab, supplyView.GetPileView("Stock"));
            }

            // THESE TWO
            var leftSideColumn = col[6] - (1.0 / 56.0) * rowScale,
                rightSideColumn = col[8] + (1.0 / 56.0) * rowScale;

            if (Absolute.Platform.isMobile()) {
                leftSideColumn = col[6] - (1.0 / 56.0) * 3.5;
                rightSideColumn = col[8] + (1.0 / 56.0) * 3.5;
            }

            pile = supplyView.GetPileView("DealStock");
            pile.CardFacing = PileView.Facing.FaceDown;
            pile.PileMode = PileView.Layout.FanRight;
            pile.FanLimit = 1;
            pile.ScaleX = pileScale;
            pile.ScaleY = pileScale;
            pile.LogicalScreenPos = new Vector2(isLeft ? leftSideColumn : rightSideColumn, botRow);
            pile.InteractionMode = PileView.Interaction.None;
            pile.DisplayType = PileView.Display.Stock;


            pile = supplyView.GetPileView("Stock");
            pile.CardFacing = PileView.Facing.FaceUp;
            pile.PileMode = PileView.Layout.FanRight;
            pile.FanLimit = 1;
            pile.ScaleX = pileScale;
            pile.ScaleY = pileScale;
            pile.LogicalScreenPos = new Vector2(isLeft ? leftSideColumn : rightSideColumn, botRow);
            pile.InteractionMode = PileView.Interaction.Click;
            pile.DisplayType = PileView.Display.Tableau;
            pile.KeyboardMode = PileView.KeyboardModes.TopCardAndEmpty;

            for (var i = 0; i < rightFocus.length; i++) {
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Tableau" + rightFocus[i]));
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.ShiftTab, supplyView.GetPileView("Tableau" + rightFocus[i]));
            }
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Waste"));
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Joker"));
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Activate, function (pv, dir) {
                if (pv instanceof PileView) // it should be!
                {
                    if (pv.Pile.Empty) {
                        //#if !GAMESTATETOOL
                        // trigger the empty pile draw
                        if (pv.SupplyView.GetKeyboardUI("dealnextdeck"))
                            pv.SupplyView.GetKeyboardUI("dealnextdeck").Keyboard.HandleKeypress(KeyboardNavigator.KeyPress.Activate);
                        //#endif
                    }
                }
                return false;
            });
            supplyView.DefaultKeyboardFocus = supplyView.GetPileView("Stock");

            pile = supplyView.GetPileView("Joker");
            pile.LogicalScreenPos = new Vector2(col[0], botRow);
            pile.CardFacing = PileView.Facing.FaceUp;
            pile.PileMode = PileView.Layout.Pile;
            pile.ScaleX = pileScale;
            pile.ScaleY = pileScale;
            pile.InteractionMode = PileView.Interaction.Click;
            pile.KeyboardMode = PileView.KeyboardModes.TopCard;
            for (var i = 0; i < rightFocus.length; i++) {
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Tableau" + rightFocus[i]));
            }
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Stock"));
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Waste"));

            pile = supplyView.GetPileView("Waste");
            pile.CardFacing = PileView.Facing.FaceUp;
            pile.PileMode = PileView.Layout.Pile;
            pile.ScaleX = pileScale;
            pile.ScaleY = pileScale;
            pile.LogicalScreenPos = new Vector2(isLeft ? rightSideColumn : leftSideColumn, botRow);
            pile.InteractionMode = PileView.Interaction.Click;
            pile.DisplayType = PileView.Display.Tableau;
            pile.KeyboardMode = PileView.KeyboardModes.TopCardAndEmpty;
            for (var i = 0; i < leftFocus.length; i++) {
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Tableau" + leftFocus[i]));
            }
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Stock"));
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Joker"));

            pile = supplyView.GetPileView("Root");
            pile.LogicalScreenPos = new Vector2(supplyView.GetPileView("Stock").LogicalScreenPos.x - 99, supplyView.GetPileView("Stock").LogicalScreenPos.y + 0.5 - 99);
            pile.DefaultPileSpacing = new Vector2(0, 0);
            pile.CardFacing = PileView.Facing.FaceDown;
            pile.PileMode = PileView.Layout.Pile;
            pile.InteractionMode = PileView.Interaction.None;

            pile = supplyView.GetPileView("Foundation");
            pile.ScaleX = pileScale;
            pile.ScaleY = pileScale;
            pile.CardFacing = PileView.Facing.Hidden;

            supplyView.CardScale = cardScale;


            this.OnMoveCardsHandler = this.UpdateStockAppearance.bind(this);
            this.OnDealHandler = function () {
                this.UpdateStockAppearance.call(this, this.supplyView);
            }.bind(this);
            this.OnDealHandlerRef = this.OnDealHandler;
            this.supplyView = supplyView;
            supplyView.OnMoveCardsEvent.add(this.OnMoveCardsHandler);
            supplyView.CardSupply.OnDealEvent.add(this.OnDealHandlerRef);


            this.UpdateStockAppearance(supplyView);
        };

        PyramidWindowsTemplate.prototype.UpdateStockAppearance = function (supply) {
            var stock = supply.GetPileView("Stock");
            if (!this._authorityReference.IsDeckPassesAvailable()) {
                if (!stock.Pile.Empty || stock.DisplayType != PileView.Display.X) {
                    setTimeout(function () {
                        stock.DisplayType = PileView.Display.X;
                        supply.GetPileView("DealStock").DisplayType = PileView.Display.X;
                    }.bind(this), 250);
                }
            } else {
                stock.DisplayType = PileView.Display.Circle;
                supply.GetPileView("DealStock").DisplayType = PileView.Display.Circle;
            }
        };

        PyramidWindowsTemplate.prototype.LoadGameOptions = function (supply) {
            supply.SetOption("PyramidTimer", this.settingsManager.getSetting('pyramid', 'timer') ? "true" : "false");
        };

        PyramidWindowsTemplate.prototype.SaveGameOptions = function (supply) {
            /*
            if (this._authorityReference.IsChallenge) {
                return;
            }
            try {
                var option = supply.GetOption("PyramidTimer");
                option = option || "false";
                // TODO Windows.Storage.ApplicationData.Current.LocalSettings.Values[TimerOptionKey] = option;
            }
            catch (e) {
            }
            */
        };

        Object.defineProperty(PyramidWindowsTemplate.prototype, "EndGameStatStrings",
            {
                get: function () {
                    return ["Time", "Score"];
                }
            });

        PyramidWindowsTemplate.prototype.GetEndGameStats = function () {
            return [
                this._authorityReference.CardSupply.CurrentTime.ToString(),
                this._authorityReference.CardSupply.Score // TODO check format
            ];
        };

        Object.defineProperty(PyramidWindowsTemplate.prototype, "GameName", {
            get: function () {
                return "Pyramid";
            }
        });

        Object.defineProperty(PyramidWindowsTemplate.prototype, "SaveFilename", {
            get: function () {
                return "PYRAMID_SAVE_FILE";
            }
        });

        Object.defineProperty(PyramidWindowsTemplate, "TimerOptionKey", {
            get: function () {
                return "APPDATA_PYRAMID_TIMER";
            }
        });

        return PyramidWindowsTemplate;

    });

